/* eslint-disable import/prefer-default-export */
import CurrentApplication_ from '../../data/models/CurrentRequestApplication';
import { SET_CURRENT_APPLICATIONS } from './actionTypes/current-applications';

export interface ICurrentApplicationsActionType {
  type: typeof SET_CURRENT_APPLICATIONS;
  payload: CurrentApplication_[];
}

export const setCurrentApplications = (applications: CurrentApplication_[]) => {
  return {
    type: SET_CURRENT_APPLICATIONS,
    payload: applications,
  };
};
